import { Outlet } from 'react-router-dom'
import TopBar from './TopBar'
import Footer from './Footer'

export default function Layout() {
  return (
    <div className="min-h-screen flex flex-col bg-[var(--color-indigo-800)]">
      <a
        href="#main"
        className="sr-only focus:not-sr-only focus:fixed focus:top-3 focus:left-3 focus:z-50 focus:px-4 focus:py-2 focus:bg-white focus:text-[var(--color-indigo-800)] focus:rounded-md focus:font-semibold"
      >
        Asosiy mazmunga oʻtish
      </a>
      <TopBar />
      <main id="main" className="flex-1">
        <Outlet />
      </main>
      <Footer />
    </div>
  )
}
